import React from "react";
import {I18nMessage} from "assecobs-faktor-web-common/index";
import {ErrorMessage} from "assecobs-faktor-web-common/forms";
import {Field} from "redux-form";
import AuthenticationPageComponent from "../../common/AuthenticationPageComponent";
import AuthenticationButtonSubmit from "../../common/AuthenticationButtonSubmit";
import AuthenticationButtonCancel from "../../common/AuthenticationButtonCancel";
import messageFactory from "../../common/messageFactory";

const InputComponent = ({input, name, label, placeholder, type, autoFocus, meta}) => (
    <div className="form-group">
        <label htmlFor={name}>{label}</label>
        <input id={name} {...input} placeholder={placeholder} type={type} className="form-control k-textbox"
               autoFocus={autoFocus}/>
        {meta && meta.error && <ErrorMessage message={meta.error}/>}
    </div>
);

export default ({error, submitting, handleSubmit, handleCancel, submit}) => (
    <AuthenticationPageComponent title="fw.authentication.resetPassword.formTitle"
                                 subtitle="fw.authentication.resetPassword.formSubtitle"
                                 submitting={submitting}
                                 msg={messageFactory.error(error)}>
        <form id="resetPasswordForm"
              onSubmit={handleSubmit(submit)}
              className="authentication-form"
        >

            <Field
                name="login"
                type="text"
                component={InputComponent}
                label={<I18nMessage id="fw.authentication.login.username"/>}
                autoFocus
            />

            <Field
                name="email"
                type="text"
                component={InputComponent}
                label={<I18nMessage id="fw.authentication.resetPassword.email"/>}
            />

            <AuthenticationButtonCancel labelKey="fw.goBack"
                                        titleKey="common.cancel"
                                        onClick={handleCancel}/>

            <AuthenticationButtonSubmit labelKey="fw.authentication.resetPassword.submit"/>

            <div className="clearfix"/>
        </form>
    </AuthenticationPageComponent>
);
